import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getGaMeasurementId, isAnalyticsEnabled, trackPageView } from '../lib/analytics';

export function Analytics() {
  const location = useLocation();

  useEffect(() => {
    if (!isAnalyticsEnabled()) {
      return;
    }

    const id = getGaMeasurementId();
    if (!id) {
      return;
    }

    if (!document.getElementById('ga4-script')) {
      const script = document.createElement('script');
      script.async = true;
      script.id = 'ga4-script';
      script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag(...args: unknown[]) {
        window.dataLayer?.push(args as unknown as never);
      };
      window.gtag('js', new Date());
      window.gtag('config', id, {
        anonymize_ip: true,
        send_page_view: false,
      });
    }
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search, document.title);
  }, [location.pathname, location.search]);

  return null;
}
